import {
  Scene,
  PerspectiveCamera,
  WebGLRenderer,
  Sprite,
  SpriteMaterial,
  LinearFilter,
  TextureLoader,
} from "three";
import DragControls from "./DragControls";

class CompareScene {
  constructor(canvasWrapper, canvas) {
    this.canvasWrapper = canvasWrapper;
    this.canvas = canvas;
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.sprite = null;
    this.textureLoader = new TextureLoader();
  }

  /**
   * Intializes apartment3DView scene.
   */
  init = (image3dUrl) => {
    const canvasWrapperPoperties = this.canvasWrapper.getBoundingClientRect();

    if (canvasWrapperPoperties.x === 0) return;

    this.scene = new Scene();
    this.camera = new PerspectiveCamera(
      65,
      canvasWrapperPoperties.width / canvasWrapperPoperties.height,
      0.1,
      1000
    );
    this.camera.position.z = 5;

    this.renderer = new WebGLRenderer({
      antialias: true,
      canvas: this.canvas,
      alpha: true,
    });
    this.renderer.setSize(
      canvasWrapperPoperties.width,
      canvasWrapperPoperties.height
    );

    this.renderer.setPixelRatio(window.devicePixelRatio);
    

    const controls = new DragControls(this.camera, this.renderer);
    controls.setAllEvents();

    window.addEventListener(
      "resize",
      () => {
        this.handleWindowResize();
      },
      false
    );

    this.initializeSpirte();
    this.updateSpriteTexture(image3dUrl);

    this.onAnimationFrameHandler();
  };

  onAnimationFrameHandler = () => {
    this.renderer.render(this.scene, this.camera);

    window.requestAnimationFrame(() =>
      this.onAnimationFrameHandler()
    );
  };

  initializeSpirte = () => {
    if (this.sprite) return this.sprite;

    this.sprite = new Sprite(new SpriteMaterial());
    this.scene.add(this.sprite);
  };

  updateSpriteTexture = (textureUrl) => {
    this.textureLoader.load(textureUrl, (texture) => {
      texture.minFilter = LinearFilter;

      const textureAspectRation = texture.image.width / texture.image.height;

      this.sprite.scale.set(6 * textureAspectRation, 6.4, 1);
      this.sprite.material.map = texture;
      this.sprite.material.needsUpdate = true;
    });
  };

  handleWindowResize = () => {
    if (this.canvasWrapper) return;

    let canvasWrapperProperties = this.canvasWrapper.getBoundingClientRect();

    this.renderer.setSize(
      canvasWrapperProperties.width,
      canvasWrapperProperties.height
    );
    this.camera.aspect =
      canvasWrapperProperties.width / canvasWrapperProperties.height;
    this.camera.updateProjectionMatrix();
  };
}

export default CompareScene;
